$(function () {
  $('#flashes .flashes__close').on('click', function (e) {
    e.preventDefault();
    var $flash = $(this).closest('#flashes');
    $flash.hide();
  });
});
